import { createSlice } from '@reduxjs/toolkit'


// POSSIBLE VALUES FOR current
// n >= 0          INDICATES THE PAGE NUMBER WHETHER IS GOING FORWARD OR BACKWARDS
// n = -1          INDICATES THE CURRENT PAGE, SO IS NOT CHANGING THE SCREEN

export const routerSlice = createSlice({
    name: 'router',
    initialState: { current: 0, length: 0, routes: [], path: undefined, direction: "forward" },
    reducers: {
        jump: (state, action) => {
            state.direction = action.payload.direction;
            // IF THE INDEX IS NOT -1, THE PAGINATION IS BY SCREENS
            if (action.payload.current !== -1) { state.current = action.payload.current }
            // IF THE INDEX IS -1 THE INDEX WONT CHANGE, IS USEFUL FOR INNER PAGINATION
            else state.path = action.payload.path;
        },
        forward: (state) => {
            state.direction = "forward";
            state.current = state.routes[state.current].next;
        },
        backward: (state) => {
            state.direction = "backward";
            state.current = state.routes[state.current].last;
        },
        skip: (state) => {
            if (state.direction === "forward") state.current = state.routes[state.current].next;
            else state.current = state.routes[state.current].last;
        },
        setRoutes: (state, action) => { state.routes = action.payload; },
        setRouterLength: (state, action) => { state.length = action.payload.length; },
    },
})

// Action creators are generated for each case reducer function
export const { forward, backward, setRouterLength, jump, setRoutes, skip } = routerSlice.actions
export default routerSlice.reducer